import gql from 'graphql-tag';

import client from '../graphqlAPI';

const CATALOG_UPDATE_RUN_MUTATION = gql`
  mutation CatalogUpdateRun($fullSync: Boolean) {
    catalogUpdateRun(fullSync: $fullSync) {
      isAuth
      success
      syncType
      totalItems
      staleItemsDeleted
      duration
      message
      error
    }
  }
`;

const catalogUpdateRun = async ({ fullSync = true } = {}) => {
  try {
    const result = await client.mutate({
      mutation: CATALOG_UPDATE_RUN_MUTATION,
      variables: { fullSync },
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    if (result && result.data && result.data.catalogUpdateRun) {
      return result.data.catalogUpdateRun;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: catalogUpdateRun = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: catalogUpdateRun Error: ${error}`);
    return null;
  }
};

export default catalogUpdateRun;
